const state = {
    customers: [],
    customer: {},
    error: null,
    editCustomer: false
};

export default state;
